import React from "react";
import { PaddedContainer } from "@disco/disco_core";

import useWidgetOffer from "../../hooks/useWidgetOffer";
import { SPACING_TARGET } from "../../hooks/useLeadGenV0Config";
import LeadGenBrand from "./LeadGenBrand";
import LeadGenAction from "./LeadGenAction";
import { LeadGenSpacer } from "./LeadGenV0";

const LeadGenOfferSlot = ({
	defaultEventProps,
	setShowOfferSlot,
	triggerWidgetResize,
	...rest
}) => {
	const {
		NUM_OFFERS_IDX,

		activeOffer,
		activeOfferIdx,

		claimOffer,
		isOfferClaimed,

		showNextOffer,
		showPrevOffer,
		isFirstOffer,
		isLastOffer,
		TOTAL_OFFERS,
		setActiveOfferIdx,
	} = useWidgetOffer();

	return (
		<PaddedContainer {...rest}>
			<LeadGenSpacer spacingTarget={SPACING_TARGET.BRAND_TOP} />
			<PaddedContainer flexContent>
				<LeadGenBrand
					brand={activeOffer}
					idx={activeOfferIdx}
					activeIdx={activeOfferIdx}
					defaultEventProps={defaultEventProps}
					isOfferClaimed={isOfferClaimed}
					key={activeOffer?.id}
				/>
			</PaddedContainer>
			<LeadGenSpacer spacingTarget={SPACING_TARGET.ACTION_MODULE_TOP} />
			<LeadGenAction
				brand={activeOffer}
				defaultEventProps={defaultEventProps}
				activeIdx={activeOfferIdx}
				maxIdx={NUM_OFFERS_IDX}
				onNext={showNextOffer}
				onPrev={showPrevOffer}
				isOfferClaimed={isOfferClaimed}
				onOfferClaimed={claimOffer}
				isLastOffer={isLastOffer}
				isFirstOffer={isFirstOffer}
				TOTAL_OFFERS={TOTAL_OFFERS}
				setActiveOfferIdx={setActiveOfferIdx}
				triggerWidgetResize={triggerWidgetResize}
				setShowOfferSlot={setShowOfferSlot}
			/>
		</PaddedContainer>
	);
};

export default LeadGenOfferSlot;
